import CertificateCheckForm from "./certificate-check-form";
import ServiceLocator from "../../../global/service-locator";
import CertificateDashboard from "./certificate-dashboard";

export default class CertificateManager {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.checkForm = new CertificateCheckForm();

		this.segments = craft.env.urlSegments ? craft.env.urlSegments : null;
		this.certificateNumber = null;
		this.data = null;

		this.certificateCheckSubscription = null;

		this.init();
	}

	init() {
		this.checkForm.init();

		if (this.segments && this.segments[0] === 'view' && this.segments[1]) {
			this.handleDirectAccess();
		} else {
			this.subscribeToCertificateCheck();
		}
 	}

 	subscribeToCertificateCheck() {
		this.certificateCheckSubscription = this.checkForm.subscribe('certificateCheckComplete', ({ detail }) => {
			if (detail) {
				this.data = detail;
				this.certificateNumber = this.data.response.refNo;
				this.initCertificateScreen();
			}
		});
	}

	handleDirectAccess() {
		this.certificateNumber = this.segments[1];
		this.checkForm.setCertificateNumber(this.certificateNumber);
		this.checkForm.requestCertificateData((data) => {
			this.data = data;

			if (this.sl.headerLoaded) {
				this.checkDataAndInitScreen();
			} else {
				this.sl.eventEmitterService.subscribe('event:header-loaded', () => {
					this.checkDataAndInitScreen();
				});
			}
		});
	}

	checkDataAndInitScreen() {
		if (!this.data) {
			this.initWelcomeScreen();
		} else {
			this.initCertificateScreen();
		}
	}

	initWelcomeScreen() {
		if (!this.certificateCheckSubscription) {
			this.subscribeToCertificateCheck();
		}

		document.body.classList.remove('-loading-screen');
		document.body.classList.add('-welcome-screen');
	}

	initCertificateScreen() {
		const certificateDashboard = new CertificateDashboard(this.data.response);
		certificateDashboard.subscribe('dashboardInitComplete', () => {
			document.body.classList.remove('-loading-screen');
			document.body.classList.remove('-welcome-screen');
			document.body.classList.add('-certificate-screen');

			this.refreshLangSwitchers();
		});
	}

	refreshLangSwitchers() {
		const $headerLangSwitcherLink = document.querySelector('.site-header [data-lang-switcher]');
		const $footerLangSwitcherLink = document.querySelector('.site-footer [data-lang-switcher]');

		if (!$headerLangSwitcherLink || !$footerLangSwitcherLink) {
			return;
		}

		const link = $headerLangSwitcherLink.href;
		const chunks = link.replace(/^http(s?):\/\//, '')
			.replace(/\/ru/g, '').split('/');

		if (chunks.length < 3 && this.certificateNumber) {
			$headerLangSwitcherLink.href = link.replace(/\/$/, '') + '/view/' + this.certificateNumber;
			$footerLangSwitcherLink.href = link.replace(/\/$/, '') + '/view/' + this.certificateNumber;
		}
	}
}